import { MenuItem, Typography } from "@mui/material";
import * as React from "react";

interface LayoutSectionProps extends React.PropsWithChildren {
  /** Whether there are any layouts to display */
  hasNoLayouts: boolean;
  /** Title of the section */
  title: string;

  /** Optional message to display when there are no layouts */
  hasNoLayoutsMessage?: string;
}

export function LayoutMenuSection({
  children,
  hasNoLayouts,
  title,
  hasNoLayoutsMessage = "No layouts yet",
}: LayoutSectionProps) {
  return (
    <>
      <MenuItem sx={{ mt: 1 }} disabled>
        <Typography variant="subtitle2">{title}</Typography>
      </MenuItem>
      {children}
      {hasNoLayouts && (
        <MenuItem disabled sx={{ typography: "body2" }}>
          {hasNoLayoutsMessage}
        </MenuItem>
      )}
    </>
  );
}
